import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SchoolService } from '../../core/school.service';

@Component({
  selector: 'app-school-forgot-password',
  templateUrl: './school-forgot-password.component.html',
  styleUrls: ['./school-forgot-password.component.css']
})
export class SchoolForgotPasswordComponent implements OnInit {
  email = '';
  sendClicked = false;

  constructor(
    private router: Router,
    private schoolService: SchoolService
  ) { }

  ngOnInit() {
  }

  send() {
    this.sendClicked = true;
    const data = {
      email: this.email
    };
    this.schoolService.forgotPassword(data)
      .subscribe(res => {
        if (res && res.success) {
          this.router.navigate(['/school/login']);
        } else {
          this.sendClicked = false;
        }
      });
  }

  isValid() {
    return (
      this.email.length &&
      !this.sendClicked
    );
  }


}
